// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const quarterCell = data => {
  // TODO - would it be better to make 'quarter' as a custom cell in place of
  // adding this property to every single record here.
  data.forEach(row => {
    if (row.month <= 3) row.quarter = 'Q1'
    else if (row.month >= 4 && row.month <= 6) row.quarter = 'Q2'
    else if (row.month >= 7 && row.month <= 9) row.quarter = 'Q3'
    else row.quarter = 'Q4'
  })

  return data
}

export default quarterCell
